import { VALIDATE_TOKEN } from '../action-types'

const initialState = {}
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case VALIDATE_TOKEN:
      return { ...state, ...payload }
    default:
      return state
  }
}
